import React, { Component } from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';

import { Spinner } from './index';

import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';

Nprogress.configure({ showSpinner: false });
Nprogress.configure({ easing: 'ease', speed: 1000 });

export default function asyncComponent(importComponent: any) {
    class AsyncFunc extends Component {
        mounted = false;

        constructor(props: any) {
            super(props);

            this.state = {
                component: null,
            };
        }

        UNSAFE_componentWillMount() {
            Nprogress.start();
        }

        async componentDidMount() {
            Nprogress.done();
            this.mounted = true;

            const { default: Component } = await importComponent();

            if (this.mounted && Component) {
                this.setState({
                    component: <Component {...this.props} />,
                });
            }
        }

        componentWillUnmount() {
            this.mounted = false;
        }

        render() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const Component = this.state.component;

            return Component ? (
                <ReactPlaceholder type="rect" rows={7} ready>
                    {Component}
                </ReactPlaceholder>
            ) : (
                <Spinner />
            );
        }
    }

    return AsyncFunc;
}
